import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, type SxProps, type Theme, Typography } from '@mui/material';

import { OperatorRootPicker } from './OperatorRootPicker';
import { type CurrentMember, type MemberRefusal } from './useCurrentMember';

const strings = appStrings.modules.coachingDashboard;

const REFUSAL_MESSAGES: Record<MemberRefusal, string> = {
  inOrganization: strings.memberRefusedInOrganization,
  access: strings.memberAccessRefused,
};

export const TabErrorMessage = ({ message }: Readonly<{ message: string }>) => (
  <Box sx={containerSx}>
    <Typography variant="text-md-regular" sx={errorTextSx}>
      {message}
    </Typography>
  </Box>
);

type MemberTabErrorStateProps = Pick<
  CurrentMember,
  'refusal' | 'operatorContextRoots' | 'onSelectOperatorInstitution'
>;

// Takes the member state as props: subscribing to the failed read here would
// re-issue it on every mount, and the refetch unmounts this state again.
export const MemberTabErrorState = ({
  refusal,
  operatorContextRoots,
  onSelectOperatorInstitution,
}: MemberTabErrorStateProps) => {
  if (operatorContextRoots !== null) {
    return (
      <Box sx={containerSx}>
        <OperatorRootPicker
          heldRoots={operatorContextRoots}
          onSelect={onSelectOperatorInstitution}
        />
      </Box>
    );
  }

  return (
    <TabErrorMessage message={refusal ? REFUSAL_MESSAGES[refusal] : strings.failedToLoadMember} />
  );
};

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  padding: backrs.spacing['spacing-xl'],
  textAlign: 'center',
});

const errorTextSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Error/600'],
});
